import y from "../../../../public/projects/experion/projects/y.jpg";
import s from "../../../../public/projects/experion/logo/s.png";
import evergreen from "../../../../public/projects/experion/projects/ev.jpg"

// thetrillion
import overviewImagethetrillion from "../../../../public/projects/experion/thetrillion/overview/1.webp";
import bannerDesktopImagethetrillion from "../../../../public/projects/experion/thetrillion/banner/1.webp";
import bannerdeveloperthetrillion from "../../../../public/projects/experion/thetrillion/banner/3.webp";
import bannerMobileImagethetrillion from "../../../../public/projects/experion/thetrillion/banner/2.webp";
import Locationthetrillion from "../../../../public/projects/experion/thetrillion/location/1.webp";
import Hightlightsthetrillion from "../../../../public/projects/experion/thetrillion/highlights/1.webp";
import floorplan1thetrillion from "../../../../public/projects/experion/thetrillion/floorplan/1.webp";
import floorplan2thetrillion from "../../../../public/projects/experion/thetrillion/floorplan/2.webp";
import floorplan3thetrillion from "../../../../public/projects/experion/thetrillion/floorplan/3.webp";
import floorplan4thetrillion from "../../../../public/projects/experion/thetrillion/floorplan/4.webp";
import floorplan5thetrillion from "../../../../public/projects/experion/thetrillion/floorplan/5.webp";
import locationiconthetrillion from "../../../../public/projects/experion/thetrillion/overview/l.png";
import caliconthetrillion from "../../../../public/projects/experion/thetrillion/overview/c.png";
import newlaunchiconthetrillion from "../../../../public/projects/experion/thetrillion/overview/n.png";
import gallery1thetrillion from "../../../../public/projects/experion/thetrillion/gallery/1.webp";
import gallery2thetrillion from "../../../../public/projects/experion/thetrillion/gallery/2.webp";
import gallery3thetrillion from "../../../../public/projects/experion/thetrillion/gallery/3.webp";
import gallery4thetrillion from "../../../../public/projects/experion/thetrillion/gallery/4.webp";
import gallery5thetrillion from "../../../../public/projects/experion/thetrillion/gallery/5.webp";


export const developerexperion = {
  properties: [
    {
      name: "Experion The Trillion",
      image: bannerdeveloperthetrillion,
      price: " 6.14 Crore Onwards",
      state: " Gurugram",
      developer: "Experion",
      location: "Sector 48, Gurugram",
      projectlocation: "Gurugram",
      bed: "3,4 BHK Apartments",
      size: "3000-3600 sq.ft.",
      url: `/experion-trillion`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Experion The Trillion",
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};
export const Headers = {
  logo: s,
  data: {
    experience: "2006",
  },
  about: `Experion, a 100% FDI funded real-estate developer, backed by Experion Holdings Pte. Ltd., Singapore, the real estate investing division of the AT Holdings group of companies. AT Capital, headquartered in Singapore, was established with the aim of capitalizing on global opportunities within both established and emerging sectors.`,
};


export const projectsexperion = {

  thetrillion: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImagethetrillion,
      bannerMobileImage: bannerMobileImagethetrillion,
      textOverlay: "",
      data: {
        title: "Experion The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Experion The Trillion",
      description: [
        "Experion The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by Experion Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at Experion Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at Experion Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of Experion The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
       
      },
      image: overviewImagethetrillion,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconthetrillion,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconthetrillion,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconthetrillion,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1thetrillion,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2thetrillion,
      }
    ],

    highlights: {
      images: Hightlightsthetrillion,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationthetrillion,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1thetrillion },
        { image: gallery2thetrillion },
        { image: gallery3thetrillion },
        { image: gallery4thetrillion },
        { image: gallery5thetrillion },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Experion The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Experion The Trillion located?",
        answer: `Experion The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at Experion The Trillion?",
        answer: `Experion The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in Experion The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at Experion The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Experion The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of Experion The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at Experion The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of Experion The Trillion?",
        answer: `Experion The Trillion is developed by Experion Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is Experion The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, Experion The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from Experion The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],
    

    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },

};
